import { FC } from "react";
import { Stack, Text } from "@chakra-ui/react";

import { formatPriceWithoutZeros } from "../../../../../../utils";

type Props = {
  amount: string;
};

export const CHDPModalAmount: FC<Props> = ({ amount }) => {
  const formattedAmount = formatPriceWithoutZeros(Number(amount));

  return (
    <Stack spacing="10px" mx="12px" mb="16px">
      <Text fontSize="13px">Сумма</Text>
      <Text fontSize="24px" variant="brand">{formattedAmount}</Text>
    </Stack>
  );
};
